/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-03 17:57:23
 * @LastEditTime: 2020-09-27 09:38:38
 * @Description: 工厂store
 */
import {
    getFactorys,
    updateFactory,
    createFactory
} from '@/api/factory'
import Vue from 'vue'

const state = {
    factoryList: [],
}

const getters = {
    getFactoryById: (state) => (id) => state.factoryList.find(x => x._id === id),
    getFactoryNameById: (state) => (id) => {
        const f = state.factoryList.find(x => x._id === id)
        return f ? f.name : null
    }
}

const actions = {
    async getFactorysAction({
        commit
    }, payload) {
        try {
            const factory = await getFactorys(payload)
            commit('SETFACTORY', factory.data)
            return factory.data
        } catch (error) {
            throw error.message
        }
    },
    async createFactoryAction({
        commit
    }, payload) {
        try {
            const newFctory = await createFactory(payload)
            commit('ADDNEWFACTORY', newFctory.data)
        } catch (error) {
            throw error.message
        }
    },
    async updateFactoryAction({
        commit
    }, payload) {
        try {
            const newFactory = await updateFactory(payload.id, payload.data)
            commit('UPDATEFACTORY', newFactory.data)
        } catch (error) {
            throw error.message
        }
    }
}

const mutations = {
    SETFACTORY(state, payload) {
        state.factoryList = payload
    },
    ADDNEWFACTORY(state, factory) {
        state.factoryList.unshift(factory);
        state.totalCounts++
    },
    UPDATEFACTORY(state, factory) {
        Vue.set(state.factoryList, state.factoryList.findIndex(x => x._id === factory._id), factory)
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}